import { z } from "zod";

import { system } from "@smart/bridge-types-basic";
import { buildSNSSQSDef } from "@smart/itops-constructs-basic";
import { buildNamespace } from "@smart/itops-types-basic";
import { wrapSchema } from "@smart/itops-utils-basic";

const SmokeballCommandResultNS = buildNamespace({
  system,
  entity: "SmokeballCommandResult",
} as const);

export const SmokeballCommandResultSchema = z.object({
  intakeCommand: z.string().optional(),
  processingEnvironmentId: z.string().optional(),
  operationId: z.string().optional(),
  args: z.object({
    commandId: z.string(),
    status: z.enum(["Success", "Failure"]),
    result: z.unknown().optional(),
    message: z.string().optional().nullable(),
  }),
});

const smokeballCommandResultGuard = wrapSchema(SmokeballCommandResultSchema);

export const SmokeballCommandResultDef = buildSNSSQSDef({
  namespace: SmokeballCommandResultNS,
  guard: smokeballCommandResultGuard,
  maxAttempts: 3,
  sqsOnly: false,
  groupKey: undefined,
  idKey: undefined,
});
